/**
 * UToast · 轻量提示
 * ------------------------------------------------------------
 * 原型对应：toast() 函数
 * 全局单例，通过 useToast() 暴露接口。
 */
import { reactive } from 'vue'

type ToastItem = { id: number; msg: string; timer: ReturnType<typeof setTimeout> }

const items = reactive<ToastItem[]>([])
let seq = 0

export function useToast() {
  function show(msg: string, ms = 2400) {
    const id = ++seq
    const timer = setTimeout(() => dismiss(id), ms)
    items.push({ id, msg, timer })
  }
  function dismiss(id: number) {
    const i = items.findIndex(t => t.id === id)
    if (i >= 0) { clearTimeout(items[i].timer); items.splice(i, 1) }
  }
  return { show, dismiss, items }
}
